import Callout from "./Callout";
import UnsupportedBrowserMessage from "./UnsupportedBrowserMessage";

const UnknownBrowser = ({ browserName, browserVersion, children }) => (
  <>
    <Callout>
      <UnsupportedBrowserMessage {...{ browserName, browserVersion }} />
    </Callout>
    {children}
  </>
);

export default UnknownBrowser;
